import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Small from 'UIComponents/elements/Small';
import { FormattedHTMLMessage, FormattedMessage } from 'LearningCenterUI/components/I18n';
import { useMostRecentExamAttempt } from '../../exams';
import { getServerSyncedTime } from '../../../utils/TimeUtils';
import { useExamRulesState } from '../examsStores';

const RetakeExamButton = ({
  cooldownHourCount = 12,
  use,
  withTooltip,
  trackId
}) => {
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    setShowExamRules
  } = useExamRulesState();
  if (!mostRecentExamAttempt) return null;
  const isInCooldown = mostRecentExamAttempt.attemptRetakeTime > getServerSyncedTime();

  const button = /*#__PURE__*/_jsx(UIButton, {
    disabled: isInCooldown,
    onClick: () => setShowExamRules(true),
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.retakeButton"
    })
  });

  if (isInCooldown) {
    if (withTooltip) {
      return /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.exams.rules.cooldownHourDurationCount",
          options: {
            cooldownHourCount
          }
        }),
        children: button
      });
    } else {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [button, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.exams.rules.cooldownHourDurationCount",
            options: {
              cooldownHourCount
            }
          })
        })]
      });
    }
  }

  return button;
};

export default RetakeExamButton;